'use client';

import { useDisconnect, useAccount } from 'wagmi';
import { WalletDropdown } from '@/components';

export const WagmiWalletDropdown = () => {
  const { address, connector } = useAccount();
  const { disconnect } = useDisconnect();

  if (!address) return null;

  return (
    <WalletDropdown
      iconSrc={connector?.icon}
      name={connector?.name}
      accountAddress={address}
      onDisconnectWallet={disconnect}
    />
  );
};
